import {Module} from 'vuex-class-modules';
import store from '@/store';
import {emailApi as api} from '@/api';
import {
  EmailAttributes as Attributes,
  EmailCreate as Create,
  EmailResource as Resource,
} from '@/interfaces';
import {ResourceType} from '@/enums';
import {CrudModuleAbstract} from './CrudModuleAbstract';
import {parseISO} from 'date-fns';

const defaultItem = (): Resource => {
  return {
    id: 'new',
    type: ResourceType.Email,
    attributes: {
      id: 0,
      body: '',
      from: '',
      messageId: '',
      recipients: [],
      subject: '',
      userCreated: {id: 0, firstName: '', lastName: ''},
      userModified: {id: 0, firstName: '', lastName: ''},
      created: new Date(),
      modified: new Date(),
    },
  };
};

@Module
class EmailModule extends CrudModuleAbstract<Resource, Attributes, Create> {
  public cast(item: Resource): Resource {
    item.attributes.created = parseISO(`${String(item.attributes.created)}`);
    item.attributes.modified = parseISO(`${String(item.attributes.modified)}`);
    return item;
  }
}

export const emailModule = new EmailModule(
  {
    store,
    name: ResourceType.Email,
  },
  () => api,
  defaultItem
);
